import React from 'react';
import type { StyleProp, ViewStyle } from 'react-native';
import { StyleSheet, View } from 'react-native';

export type PercentageBarContainerProps = {
    children: React.ReactNode;
    vertical?: boolean;
    style?: StyleProp<ViewStyle>;
    backgroundColor?: string;
    thickness?: number;
};
export function PercentageBarContainer({ children, vertical, style, backgroundColor, thickness }: PercentageBarContainerProps) {
    let barStyle: ViewStyle = {
        flexDirection: vertical ? 'column-reverse' : 'row',
        backgroundColor: backgroundColor,
        flexGrow: !thickness ? 1 : 0,
        width: vertical && thickness ? thickness : null,
        height: !vertical && thickness ? thickness : null,
        borderRadius: 4,
    };

    barStyle = {
        ...barStyle,
        ...StyleSheet.flatten(style),
    };
    return <View style={barStyle}>{children}</View>;
}

export type PercentageSegmentProps = {
    children?: React.ReactNode;
    percentage: number;
    color?: string;
};

export function PercentageSegment({ children, percentage, color }: PercentageSegmentProps) {
    let elementStyle: ViewStyle = {
        backgroundColor: color,
        flex: percentage,
        overflow: 'hidden',
    };

    elementStyle = {
        ...elementStyle,
    };

    return <View style={elementStyle}>{children}</View>;
}

export type PercentageBarProps = {
    children?: React.ReactNode;
    percentages: number[];
    colors: string[];
    totalValue?: number;
};

export function PercentageBar({ children, percentages, colors, totalValue = 100 }: PercentageBarProps) {
    const sum = percentages.reduce((accumulator, currentValue) => {
        return accumulator + currentValue;
    }, 0);

    const childrenArray = React.Children.toArray(children);

    return (
        <>
            {percentages.map((p, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <PercentageSegment color={colors[i]} key={i} percentage={p}>
                    {childrenArray[i]}
                </PercentageSegment>
            ))}
            <PercentageSegment percentage={totalValue - sum}></PercentageSegment>
        </>
    );
}
